var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingTopLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_257)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 14,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(90 188 14)",
    fill: "#007FFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 14,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(90 188 14)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3536 21.6464C92.1583 21.4512 91.8417 21.4512 91.6464 21.6464L88.4645 24.8284C88.2692 25.0237 88.2692 25.3403 88.4645 25.5355C88.6597 25.7308 88.9763 25.7308 89.1716 25.5355L92 22.7071L94.8284 25.5355C95.0237 25.7308 95.3403 25.7308 95.5355 25.5355C95.7308 25.3403 95.7308 25.0237 95.5355 24.8284L92.3536 21.6464ZM91.6464 47.3536C91.8417 47.5488 92.1583 47.5488 92.3536 47.3536L95.5355 44.1716C95.7308 43.9763 95.7308 43.6597 95.5355 43.4645C95.3403 43.2692 95.0237 43.2692 94.8284 43.4645L92 46.2929L89.1716 43.4645C88.9763 43.2692 88.6597 43.2692 88.4645 43.4645C88.2692 43.6597 88.2692 43.9763 88.4645 44.1716L91.6464 47.3536ZM91.5 22L91.5 47L92.5 47L92.5 22L91.5 22Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 55L188 79C188 81.7614 185.761 84 183 84L13 84C10.2386 84 8 81.7614 8 79L8 55L188 55Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.653 80.9273C187.877 80.3275 188 79.6781 188 79C188 79.6718 187.836 80.3093 187.543 80.8818L187.653 80.9273ZM185.025 83.8876L184.747 83.2177C184.203 83.4002 183.614 83.5 183 83.5L180.976 83.5L180.976 84.5L182.5 84.5C182.669 84.5 182.835 84.4924 183 84.4776C183.725 84.4123 184.409 84.2065 185.025 83.8876ZM176.929 84.5L176.929 83.5L172.881 83.5L172.881 84.5L176.929 84.5ZM168.833 84.5L168.833 83.5L164.786 83.5L164.786 84.5L168.833 84.5ZM160.738 84.5L160.738 83.5L156.69 83.5L156.69 84.5L160.738 84.5ZM152.643 84.5L152.643 83.5L148.595 83.5L148.595 84.5L152.643 84.5ZM144.548 84.5L144.548 83.5L140.5 83.5L140.5 84.5L144.548 84.5ZM136.452 84.5L136.452 83.5L132.405 83.5L132.405 84.5L136.452 84.5ZM128.357 84.5L128.357 83.5L124.31 83.5L124.31 84.5L128.357 84.5ZM120.262 84.5L120.262 83.5L116.214 83.5L116.214 84.5L120.262 84.5ZM112.167 84.5L112.167 83.5L108.119 83.5L108.119 84.5L112.167 84.5ZM104.071 84.5L104.071 83.5L100.024 83.5L100.024 84.5L104.071 84.5ZM95.9762 84.5L95.9762 83.5L91.9286 83.5L91.9286 84.5L95.9762 84.5ZM87.8809 84.5L87.8809 83.5L83.8333 83.5L83.8333 84.5L87.8809 84.5ZM79.7857 84.5L79.7857 83.5L75.7381 83.5L75.7381 84.5L79.7857 84.5ZM71.6904 84.5L71.6904 83.5L67.6428 83.5L67.6428 84.5L71.6904 84.5ZM63.5952 84.5L63.5952 83.5L59.5476 83.5L59.5476 84.5L63.5952 84.5ZM55.5 84.5L55.5 83.5L51.4523 83.5L51.4523 84.5L55.5 84.5ZM47.4047 84.5L47.4047 83.5L43.3571 83.5L43.3571 84.5L47.4047 84.5ZM39.3095 84.5L39.3095 83.5L35.2618 83.5L35.2618 84.5L39.3095 84.5ZM31.2142 84.5L31.2142 83.5L27.1666 83.5L27.1666 84.5L31.2142 84.5ZM23.119 84.5L23.119 83.5L19.0713 83.5L19.0713 84.5L23.119 84.5ZM15.0237 84.5L15.0237 83.5L13 83.5C12.3855 83.5 11.7969 83.4002 11.2531 83.2177L10.9753 83.8876C11.5914 84.2065 12.2754 84.4123 13 84.4776C13.1647 84.4924 13.3315 84.5 13.5 84.5L15.0237 84.5ZM8.34715 80.9273L8.45685 80.8818C8.16357 80.3093 8 79.6718 8 79C8 79.6781 8.12271 80.3275 8.34715 80.9273ZM188 55.5L188 55L188 54.5L186.043 54.5L186.043 55.5L188 55.5ZM182.13 55.5L182.13 54.5L178.217 54.5L178.217 55.5L182.13 55.5ZM174.304 55.5L174.304 54.5L170.391 54.5L170.391 55.5L174.304 55.5ZM166.478 55.5L166.478 54.5L162.565 54.5L162.565 55.5L166.478 55.5ZM158.652 55.5L158.652 54.5L154.739 54.5L154.739 55.5L158.652 55.5ZM150.826 55.5L150.826 54.5L146.913 54.5L146.913 55.5L150.826 55.5ZM143 55.5L143 54.5L139.087 54.5L139.087 55.5L143 55.5ZM135.174 55.5L135.174 54.5L131.261 54.5L131.261 55.5L135.174 55.5ZM127.348 55.5L127.348 54.5L123.435 54.5L123.435 55.5L127.348 55.5ZM119.522 55.5L119.522 54.5L115.609 54.5L115.609 55.5L119.522 55.5ZM111.696 55.5L111.696 54.5L107.783 54.5L107.783 55.5L111.696 55.5ZM103.87 55.5L103.87 54.5L99.9565 54.5L99.9565 55.5L103.87 55.5ZM96.0435 55.5L96.0435 54.5L92.1305 54.5L92.1305 55.5L96.0435 55.5ZM88.2174 55.5L88.2174 54.5L84.3044 54.5L84.3044 55.5L88.2174 55.5ZM80.3913 55.5L80.3913 54.5L76.4783 54.5L76.4783 55.5L80.3913 55.5ZM72.5653 55.5L72.5653 54.5L68.6522 54.5L68.6522 55.5L72.5653 55.5ZM64.7392 55.5L64.7392 54.5L60.8261 54.5L60.8261 55.5L64.7392 55.5ZM56.9131 55.5L56.9131 54.5L53 54.5L53 55.5L56.9131 55.5ZM49.087 55.5L49.087 54.5L45.174 54.5L45.174 55.5L49.087 55.5ZM41.2609 55.5L41.2609 54.5L37.3479 54.5L37.3479 55.5L41.2609 55.5ZM33.4348 55.5L33.4348 54.5L29.5218 54.5L29.5218 55.5L33.4348 55.5ZM25.6088 55.5L25.6088 54.5L21.6957 54.5L21.6957 55.5L25.6088 55.5ZM17.7827 55.5L17.7827 54.5L13.8696 54.5L13.8696 55.5L17.7827 55.5ZM9.9566 55.5L9.9566 54.5L8 54.5L8 55L8 55.5L9.9566 55.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -52,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -52,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 92,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 92,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingTopLg);
export default __webpack_public_path__ + "static/media/padding_top_lg.a78774641cd443e6a65a91b9f02ab688.svg";
export { ForwardRef as ReactComponent };